// @flow

// Utils
import { isEmpty } from './string';
import { isObjEmpty } from './varValidation';

// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

export const setTransportationLabel = (idLabel: Object, intl: IntlShape) => {
  if (!isObjEmpty(idLabel)) {
    if (!isEmpty(idLabel.configureString)) {
      return intl.formatMessage({ id: idLabel.configureString });
    } else {
      const strId = intl.formatMessage({ id: idLabel.id });
      if (strId !== idLabel.id && !isEmpty(strId)) {
        return strId;
      } else {
        return intl.formatMessage({ id: idLabel.defaultId });
      }
    }
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/utils/transportationLabel.js